module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Manipal-ac2be2fbb4cdcb3339b2162c1244e955.png";